import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { ThemeConfig } from '../model';

export const THEMES_CONFIG = new InjectionToken<ThemeConfig>('THEMES_CONFIG');

export const THEME_CONTEXT = new HttpContextToken<{ loader: { toggle: boolean } } | undefined>(() => undefined);
